import PropTypes from 'prop-types';
import { Skeleton, Box, Typography } from '@mui/material';
import { getUnitForPower } from '../../utils/apiCommonMethods';
import { AppChartCard } from '../@dashboard/app';

BatteryPowerChart.propTypes = {
  site: PropTypes.object.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  series: PropTypes.array,
  loading: PropTypes.bool,
  hasData: PropTypes.bool,
  hidden: PropTypes.bool,
  onToggleExpand: PropTypes.func,
};

export default function BatteryPowerChart({
  site,
  startDate,
  endDate,
  series = [],
  loading = false,
  hasData = false,
  hidden = false,
  onToggleExpand,
}) {
  if (hidden) return null;

  if (loading) {
    return (
      <Box sx={{ minHeight: 320 }}>
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: 'background.paper',
            boxShadow: 1,
          }}
        >
          <Skeleton variant="text" width="45%" height={32} />
          <Skeleton variant="text" width="25%" height={24} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={242} sx={{ borderRadius: 2 }} />
        </Box>
      </Box>
    );
  }

  if (!hasData) {
    return (
      <Box sx={{ minHeight: 320, textAlign: 'center', pt: 5 }}>
        <Typography variant="body2">No battery power data available.</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <AppChartCard
        sx={{ height: '100%' }}
        title="Battery Power"
        subheader={getUnitForPower(site?.id)}
        chartData={series}
        xMinMs={startDate?.valueOf()}
        xMaxMs={endDate?.valueOf()}
        expandContractChart={onToggleExpand}
      />
    </Box>
  );
}